// AGC: [#9] Translate the EMBRAPA/Portuguese phenological stage NAMES (from CROP_CYCLE_DATA in
// AGC: types/lot.ts) at render time, keyed by the PT name. The same stage CODE means different things
// AGC: per crop (e.g. R1 = Floração in soja but Espigamento in milho), so we map by name, not code.
// AGC: This does NOT change the underlying data — for pt locale the label is identical, so Brazil is
// AGC: unaffected; es/en users see the translated stage name.

// AGC: PT stage name -> i18n key suffix under fields.growthStages.*
const STAGE_KEY: Record<string, string> = {
  'Emergência': 'emergence',
  'Vegetativo': 'vegetative',
  'Vegetativo 1': 'vegetative1',
  'Vegetativo 4': 'vegetative4',
  'Vegetativo 8': 'vegetative8',
  'Floração': 'flowering',
  'Formação Vagens': 'podFormation',
  'Enchimento Grãos': 'grainFilling',
  'Enchimento': 'filling',
  'Maturação': 'maturation',
  'Colheita': 'harvest',
  'Pendoamento': 'tasseling',
  'Espigamento': 'heading',
  'Grão Leitoso': 'milkGrain',
  'Grão Dentado': 'dentGrain',
  'Perfilhamento': 'tillering',
  'Alongamento': 'stemElongation',
  'Botões Florais': 'flowerBuds',
  'Capulhos': 'bolls',
  'Folhas Primárias': 'primaryLeaves',
}

/**
 * AGC: Return the localized stage label for a CROP_CYCLE_DATA stage name. Falls back to the original
 * AGC: name when there is no mapping (so unknown/admin-added stages still render).
 */
export const growthStageLabel = (name: string | undefined, t: (key: string) => string): string => {
  if (!name) return ''
  const key = STAGE_KEY[name]
  return key ? t(`fields.growthStages.${key}`) : name
}
